/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import Vue from "vue";
import {
    Dialog,
    Input,
    Loading as ElLoading,
    MessageBox,
    Notification,
    Pagination as ElPagination,
    Tag,
    Tooltip,
} from 'element-ui'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
import simplebar from "simplebar-vue";
import Swiper from "swiper";
import Validator from 'validatorjs';
import Loading from "vue-loading-overlay";
import VueScrollTo from "vue-scrollto";
import DatePicker from "vue2-datepicker";
import Pagination from "@/components/custom/Pagination";
import VueSlider from 'vue-slider-component'
import router from './router'
import store from './store'
import {
    AlertPlugin,
    ButtonPlugin,
    CardPlugin,
    FormCheckboxPlugin,
    FormGroupPlugin,
    FormInputPlugin,
    FormRadioPlugin,
    InputGroupPlugin,
    LinkPlugin,
    ListGroupPlugin,
    ModalPlugin,
    TablePlugin,
    TooltipPlugin,
} from 'bootstrap-vue'

window.Vue = require('vue');

require('./sentry');
require('swiper/js/swiper');
require('./bootstrap');
require('./filters');
require('./forms/bootstrap');

locale.use(lang);

// element-ui
Vue.use(ElLoading.directive);
Vue.prototype.$notify = Notification;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$loading = ElLoading.service;
Vue.component(ElPagination.name, ElPagination);
Vue.component(Tag.name, Tag);
Vue.component(Input.name, Input);
Vue.component(Tooltip.name, Tooltip);

Vue.component('pagination', Pagination);
Vue.component(Dialog.name, Dialog);
Vue.component('DatePicker', DatePicker);
Vue.component('loading', Loading);
Vue.component('simplebar', simplebar);
Vue.component('VueSlider', VueSlider);

Vue.use(TablePlugin);
Vue.use(FormRadioPlugin);
Vue.use(ModalPlugin);
Vue.use(ButtonPlugin);
Vue.use(FormGroupPlugin);
Vue.use(FormInputPlugin);
Vue.use(AlertPlugin);
Vue.use(TooltipPlugin);
Vue.use(CardPlugin);
Vue.use(ListGroupPlugin);
Vue.use(InputGroupPlugin);
Vue.use(LinkPlugin);
Vue.use(FormCheckboxPlugin);

Vue.use(VueScrollTo);
Vue.use(VueScrollTo, {
    container: "body",
    duration: 500,
    easing: "ease",
    offset: 0,
    force: true,
    cancelable: true,
    onStart: false,
    onDone: false,
    onCancel: false,
    x: false,
    y: true
});

window.Bus = new Vue({});
window.Swiper = new Swiper('.swiper-container', {
    spaceBetween: 10,
    slidesPerView: 4,
    loop: true,
    freeMode: true,
    loopedSlides: 5, //looped slides should be the same
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
});

Validator.registerAsync('vin', function (value, req, attribute, passes) {
    let form = new Form({
        vin: value,
        vehicle_id: req
    });
    window.App.post('/web-api/vehicle/validate-unique-vin', form)
        .then(() => {
            if (passes) {
                passes();
            }
        })
        .catch((response) => {
            if (passes) {
                passes(false, 'The vin has already been taken.');
            }
        });

});

Validator.registerAsync('stock_id', function (value, req, attribute, passes) {
    let form = new Form({
        stock_id: value,
        vehicle_id: req
    });
    window.App.post('/web-api/vehicle/validate-unique-stock-id', form)
        .then(() => {
            if (passes) {
                passes();
            }
        })
        .catch((response) => {
            if (passes) {
                passes(false, 'The stock id has already been taken.');
            }
        });

});

Validator.registerAsync('unique_email', function (value, attribute, req, passes) {
    let form = new Form({
        email: value
    });
    window.App.post('/web-api/user/validate-unique-email', form)
        .then(() => {
            if (passes) {
                passes();
            }
        })
        .catch((response) => {
            if (passes) {
                passes(false, 'The email has already been taken.');
            }
        });

});


const App = require('./components/App').default;

const app = new Vue({
    components: {App},
    template: "<App/>",
    router,
    store,
    mounted() {
        !function($) {
            "use strict";

            var MainApp = function() {};

            MainApp.prototype.intSlimscrollmenu = function () {
                $('.slimscroll-menu').slimscroll({
                    height: '100vh',
                    position: 'right',
                    size: "5px",
                    color: '#9ea5ab',
                    wheelStep: 5,
                    touchScrollStep: 50
                });
            },
                MainApp.prototype.initSlimscroll = function () {
                    $('.slimscroll').slimscroll({
                        height: '500px',
                        position: 'right',
                        size: "5px",
                        color: '#9ea5ab',
                        touchScrollStep: 50
                    });
                },

                MainApp.prototype.initMetisMenu = function () {
                    //metis menu
                    $("#side-menu").metisMenu()
                        .on('shown.metisMenu', function() {
                            $("ul.submenu.collapse.in").removeClass('collapse')
                        });
                },

                MainApp.prototype.initLeftMenuCollapse = function () {
                    // Left menu collapse
                    $('.button-menu-mobile').on('click', function (event) {
                        event.preventDefault();
                        $("body").toggleClass("enlarged");
                        window.Bus.$emit('onClickButtonMenu');
                    });
                },

                MainApp.prototype.initEnlarge = function () {
                    if ($(window).width() < 1025) {
                        $('body').addClass('enlarged');
                    } else {
                        $('body').removeClass('enlarged');
                    }
                },

                MainApp.prototype.initComponents = function () {
                    $('[data-toggle="tooltip"]').tooltip();
                    $('[data-toggle="popover"]').popover();
                },

                MainApp.prototype.initHeaderCharts = function () {
                    $('#header-chart-1').sparkline([8, 6, 4, 7, 10, 12, 7, 4, 9, 12, 13, 11, 12], {
                        type: 'bar',
                        height: '35',
                        barWidth: '5',
                        barSpacing: '3',
                        barColor: '#7A6FBE'
                    });
                    $('#header-chart-2').sparkline([8, 6, 4, 7, 10, 12, 7, 4, 9, 12, 13, 11, 12], {
                        type: 'bar',
                        height: '35',
                        barWidth: '5',
                        barSpacing: '3',
                        barColor: '#29bbe3'
                    });
                },

                MainApp.prototype.init = function () {
                    this.intSlimscrollmenu();
                    this.initSlimscroll();
                    this.initMetisMenu();
                    this.initLeftMenuCollapse();
                    this.initEnlarge();
                    this.initComponents();
                    this.initHeaderCharts();
                    Waves.init();
                },

                //init
                $.MainApp = new MainApp, $.MainApp.Constructor = MainApp
        }(window.jQuery),

//initializing
            function ($) {
                "use strict";
                $.MainApp.init();
            }(window.jQuery);
    }
}).$mount('#app');
